export const CarouselDirections = {
    LEFT: 'left',
    RIGHT: 'right',
};

export const CarouselThemes = {
    LIGHT: 'light',
    DARK: 'dark',
};
